import { render, staticRenderFns } from "./FormUsuarios.vue?vue&type=template&id=4abfb8fa&"
import script from "./FormUsuarios.vue?vue&type=script&lang=js&"
export * from "./FormUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports